import { getApiBackendDomain } from "./get-backend-api-domain";

const metaEnv = import.meta.env;

export const env = {
  env: metaEnv.VITE_ENV,
  SENTRY_DSN: metaEnv.VITE_SENTRY_DSN,
  isDev: metaEnv.DEV,
  FF_CO_SELECTION: metaEnv.VITE_FF_CO_SELECTION,
  HOMEOWNER_ID: metaEnv.VITE_HOMEOWNER_ID,
  HOMEOWNER_TOKEN: metaEnv.VITE_HOMEOWNER_TOKEN,
  FEATURE_TESTS: metaEnv.VITE_FEATURE_TESTS,
  LEAD_PHONE: metaEnv.VITE_LEAD_PHONE,
  SESSION_ID: metaEnv.VITE_SESSION_ID,
  GMAP_API_KEY: metaEnv.VITE_GMAP_API_KEY,
  SIGNUP_NETWORKS: metaEnv.VITE_SIGNUP_NETWORKS,
  ZIP_CODE: metaEnv.VITE_ZIP_CODE,
  API_BACKEND: getApiBackendDomain(window.location.host, metaEnv.VITE_API_BACKEND),
} as const;


declare global {
  interface ImportMetaEnv {
    readonly VITE_ENV: string;
    readonly VITE_SESSION_ID: string;
    readonly VITE_HOMEOWNER_ID: string;
    readonly VITE_HOMEOWNER_TOKEN: string;
    readonly DEV: boolean;
    readonly VITE_FF_CO_SELECTION: boolean;
    readonly VITE_FEATURE_TESTS: string;
    readonly VITE_LEAD_PHONE: string;
    readonly VITE_GMAP_API_KEY: string;
    readonly VITE_SIGNUP_NETWORKS: Record<string, string>;
    readonly VITE_ZIP_CODE: string;
    readonly VITE_API_BACKEND: string;
    readonly VITE_SENTRY_DSN: string;
    // more env variables...
  }
  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}
